<script>
  import UploadSection from '../components/UploadSection.svelte';
  import { useEditorV2Setup } from '../EditorV2Pages/setup.js';
  useEditorV2Setup();
</script>

<UploadSection />